'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMountModels = getMountModels;
exports.getUnmountModels = getUnmountModels;
exports.getUpdatedModels = getUpdatedModels;
exports.getUpdatedModelsInPath = getUpdatedModelsInPath;
exports.minimalChangeSet = minimalChangeSet;
exports.diff = diff;

var _ramda = require('ramda');

var _model = require('../model');

var _path = require('../path');

var containsPeer = function containsPeer(list) {
  return function (m) {
    return (0, _ramda.any)((0, _ramda.bind)(m.isPeer, m))(list);
  };
};

function getMountModels(oldModels, newModels) {
  return (0, _ramda.reject)(containsPeer(oldModels), newModels);
}

function getUnmountModels(oldModels, newModels) {
  return (0, _ramda.reject)(containsPeer(newModels), oldModels);
}

function getUpdatedModels(oldModels, newModels) {
  return (0, _ramda.reduce)(function (memo, om) {
    var counterpart = (0, _ramda.find)((0, _ramda.bind)(om.isPeer, om), newModels);

    // are peer models but object pointer are different
    if (counterpart && counterpart !== om) {
      return (0, _ramda.append)({ oldModel: om, newModel: counterpart }, memo);
    } else {
      return memo;
    }
  }, [], oldModels);
}

function getUpdatedModelsInPath(oldRootModel, newRootModel, path) {
  var intermediatePaths = (0, _path.getIntermidiatePaths)(path);

  return (0, _ramda.reduce)(function (memo, p) {
    var oldModel = oldRootModel.getIn(p);

    if ((0, _model.isModel)(oldModel)) {
      return (0, _ramda.append)({
        oldModel: oldModel,
        newModel: newRootModel.getIn(p)
      }, memo);
    } else {
      return memo;
    }
  }, [], intermediatePaths);
}

var getModelChildren = function getModelChildren(m) {
  return (0, _ramda.map)(_ramda.head, m.childModels());
};
var getModelDescendants = function getModelDescendants(m) {
  return (0, _ramda.map)(_ramda.head, m.childModelsRecursive());
};

function minimalChangeSet(om, nm) {
  var oldChildModels = getModelChildren(om);
  var newChildModels = getModelChildren(nm);

  var mountedModels = getMountModels(oldChildModels, newChildModels);
  var childMountedModels = (0, _ramda.flatten)((0, _ramda.map)(getModelDescendants, mountedModels));

  var unmountedModels = getUnmountModels(oldChildModels, newChildModels);
  var childUnmountedModels = (0, _ramda.flatten)((0, _ramda.map)(getModelDescendants, unmountedModels));

  var updatedModels = getUpdatedModels(oldChildModels, newChildModels);
  var childUpdatedModels = (0, _ramda.reduce)(function (memo, _ref) {
    var oldModel = _ref.oldModel,
        newModel = _ref.newModel;

    var _minimalChangeSet = minimalChangeSet(oldModel, newModel),
        childMountedModelsInUpdatedModels = _minimalChangeSet.mountedModels,
        childUnmountedModelsInUpdatedModels = _minimalChangeSet.unmountedModels,
        childUpdatedModelsInUpdatedModels = _minimalChangeSet.updatedModels;

    return {
      mountedModels: (0, _ramda.concat)(childMountedModelsInUpdatedModels, memo.mountedModels),
      unmountedModels: (0, _ramda.concat)(childUnmountedModelsInUpdatedModels, memo.unmountedModels),
      updatedModels: (0, _ramda.concat)(childUpdatedModelsInUpdatedModels, memo.updatedModels)
    };
  }, {
    mountedModels: [],
    unmountedModels: [],
    updatedModels: []
  }, updatedModels);

  return {
    mountedModels: (0, _ramda.concat)((0, _ramda.concat)(childUpdatedModels.mountedModels, childMountedModels), mountedModels),
    unmountedModels: (0, _ramda.concat)((0, _ramda.concat)(childUpdatedModels.unmountedModels, childUnmountedModels), unmountedModels),
    updatedModels: (0, _ramda.concat)(childUpdatedModels.updatedModels, updatedModels)
  };
}

function diff(oldRootModel, newRootModel, path) {
  if (oldRootModel === newRootModel) {
    return {
      mountedModels: [],
      unmountedModels: [],
      updatedModels: []
    };
  }

  var oldReactorModel = oldRootModel.getIn(path);
  var newReactorModel = newRootModel.getIn(path);

  var _minimalChangeSet2 = minimalChangeSet(oldReactorModel, newReactorModel),
      mountedModels = _minimalChangeSet2.mountedModels,
      unmountedModels = _minimalChangeSet2.unmountedModels,
      updatedModels = _minimalChangeSet2.updatedModels;

  var updatedModelsInPath = getUpdatedModelsInPath(oldRootModel, newRootModel, path);

  return {
    mountedModels: mountedModels,
    unmountedModels: unmountedModels,
    updatedModels: (0, _ramda.concat)(updatedModelsInPath, updatedModels)
  };
}